import $ from 'jquery';
import fetch from 'utils/fetch';
import { bootstrapUI } from 'plugins/bootstrap';
import { displayEdit } from './api';
import { renderApplication } from 'modules/product';

export const displayEditionModal = (evt, product, savedCb) => {
  const $button = $(evt.target);

  $button.addClass('loading');
  displayEdit(product).then(modal => {
    $button.removeClass('loading');

    // Appending modal to content then handling behavior
    $(document.body).append(modal);

    const $modal = $('#modal-edit-product');
    const bindForm = () => {
      bootstrapUI($modal);
      renderApplication(true);
    };

    $modal
      .modal({
        onVisible: () => {
          const $submitBt = $modal.find('.button.approve');

          bindForm();

          const $forms = $modal.find('form');
          $forms.on('submit', evt => {
            evt.preventDefault();

            const $form = $(evt.target);

            // Serializing and submitting form
            const data = new FormData($form[0]);
            const action = $form.attr('action');

            $submitBt.addClass('loading');

            fetch(action, {
              method: 'POST',
              body: data,
            }).then(
              res => {
                $submitBt.removeClass('loading');

                // Calling callback
                res
                  .json()
                  .then(product => savedCb(product))
                  .then(_ => $modal.modal('hide'));
              },
              err => {
                console.log('Error attempting to update product', err);
                $submitBt.removeClass('loading');

                // Displaying validation error
                err.res.text().then(content => {
                  $form.html(content);
                  bindForm();
                });
              }
            );

            return false;
          });
        },
        onHidden: () => {
          $modal.find('form').trigger('reset');
          $modal.remove();
        },
        onApprove: element => {
          const $form = $(element)
            .closest('.modal')
            .find('form:visible');
          $form.trigger('submit');

          return false;
        },
      })
      .modal('show');
  });
};



// WEBPACK FOOTER //
// ./src/modules/saas/products/modals.js